import { useState, useEffect } from "react";
import {
    StyleSheet, View, Text, Pressable
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';
import { ReactComponent as MoreImg } from '../../../img/ico-prefix-more.svg';
import { ReactComponent as CloseImg } from '../../../img/ico-prefix-close.svg';
import { useTranslation } from "react-i18next";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";
import CustomRadioBtn from "components/base/CustomRadioBtn";
import { checkUpperString, deepCopyObject } from "common/util";
import CustomText from "components/base/CustomText";

interface IngressRoleType {
    hostUrl:string,
    protocolTypeCode:string,
    path:string,
    pathTypeCode:string,
    backendTypeCode:string,
    serviceSelectType:string,
    backendName:string,
    backendPort:number,
    serviceId:string,
    timestamp?:number
}
interface IngressAddProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    showSlideModalCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
};

IngressAdd.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}


export default function IngressAdd(props:IngressAddProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeAddYn, setExecuteAddYn] = useState(false);
    
    // 기본정보
    const [ingressName, setIngressName] = useState("");
    const [ingressDescription, setIngressDescription] = useState("");
    // 상세정보
    const [projectId, setProjectId] = useState("");
    const [containerClusterId, setContainerClusterId] = useState("");
    const [namespaceId, setNamespaceId] = useState("");
    const [ingressClass, setIngressClass] = useState("");
    const [ingressAnnotations, setIngressAnnotation] = useState("");
    const [ingressLabel, setIngressLabel] = useState("");
    const [ingressRoles, setIngressRoles] = useState<IngressRoleType[]>([]);
    const [newRole, setNewRole] = useState<IngressRoleType>(
        {
            hostUrl: '',
            protocolTypeCode: 'HTTP',
            path: '',
            pathTypeCode: 'PREFIX',
            backendTypeCode: 'SVC',
            serviceSelectType: '',
            backendName: '',
            backendPort: 0,
            serviceId: ''
        }
    );
    // Alert
    const [ingressNameWarnYn, setIngressNameWarnYn] = useState(false);
    // 상세정보 DropDownList 옵션
    const [projectList, setProjectList] = useState<DropdownType[]>([]);
    const [containerClusterList, setContainerClusterList] = useState<DropdownType[]>([]);
    const [namespaceList, setNamespaceList] = useState<DropdownType[]>([]);
    const [serviceList, setServiceList] = useState<DropdownType[]>([]);
    const [roleChangeYn, setRoleChangeYn] = useState(false);
    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);

    useEffect(() => {
        if(stepIndex === 0) {
            loadProjectList();
        }
    }, [stepIndex])
    useEffect(() => {
        if(projectId) {
            loadContainerClusterList();
        }
    }, [projectId])

    useEffect(() => {
        if(containerClusterId) {
            loadNamespaceList();
            setNamespaceId("");
        }
    }, [containerClusterId]);

    useEffect(() => {
        if(containerClusterId && namespaceId) {
            loadServiceList();
        }
    }, [containerClusterId, namespaceId]);

    useEffect(() => {
        if(roleChangeYn) {
            setRoleChangeYn(false);
        }
    }, [roleChangeYn]);

    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {

                }
            } else {
                const successYn = checkIngressData();
                if(successYn) {
                    setExecuteAddYn(true);
                } else {
                    executeResult({successYn: false}, false, '');
                }
            }
        }
    }, [props.clickedConfirmYn]);

    useEffect(() => {
        if(executeAddYn) {
            executeAddIngress();
        }
    }, [executeAddYn]);

    function checkIngressData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setIngressNameWarnYn(false)
        let message = "";
        let error = false;
        if(!ingressName || !ingressClass) {
            message = t("MESSAGE_NAMESPACE_INFO_ENTER_ERROR_MESSAGE")
            error = true;
            if(!ingressName) {
                setIngressNameWarnYn(true);
            }
        }

        if(!checkUpperString(ingressName)) {
            message = t("MESSAGE_NAMESPACE_INFO_ENTER_ERROR_MESSAGE");
            setIngressNameWarnYn(true);
            error = true;
        }
        if(error === true) {
            executeResult({}, false, message);
        }
        
        return !error;
    }

    function executeResult(result, closeYn, infoMessage) {
        setExecuteAddYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }

    function executeAddIngress() {
        const ingressRoleData = ingressRoles.map((role)=>{
            const host_url = role.hostUrl;
            const protocol_type_code = role.protocolTypeCode;   // HTTP로 고정
            const path = role.path;
            const path_type_code = role.pathTypeCode;       // PREFIX로 고정
            const backend_type_code = role.backendTypeCode; // SVC로 고정
            const backend_name = role.backendName ? role.backendName : null;
            const backend_port = role.backendPort;
            const service = role.serviceId ? {service_id:role.serviceId} : null
            return {
                host_url,
                protocol_type_code,
                path,
                path_type_code,
                backend_type_code,
                backend_name,
                backend_port,
                service
            }
        })

        const addPackageData = {
            ingress: {
                ingress_name: ingressName,
                ingress_description: ingressDescription,
                labels: ingressLabel,
                ingress_class_name: ingressClass,            // nginx로 고정
                annotations: ingressAnnotations
            },
            ingress_rules:ingressRoleData,
            namespace:{
                namespace_id: namespaceId
            },
            container_cluster:{
                container_cluster_id: containerClusterId   
            },
            project:{
                project_id: projectId
            }
        };
        requests.post(PLATFORM_URL.INGRESS, addPackageData)
        .then((response) => {
            executeResult({successYn: true }, true, "");
        })
        .catch((error) => {
            if(error.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_INGRESS_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        });
    }

    // 프로젝트 옵션리스트 조회
    function loadProjectList() {
        requests.get(PLATFORM_URL.PROJECT, {size: 9999})
        .then((response) => {
            if (response.status === 200 && response.data?.items) {
                setProjectList(response.data.items.map((data, index) => {
                    return { value: data.project_id, label: data.project_name };
                }));
            }
        })
        .catch((error) => {
            if(props.showMessageCb) {
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }
    // 클러스터 옵션리스트 조회
    function loadContainerClusterList() {
        requests.get(PLATFORM_URL.PROJECT + '/' + projectId + PLATFORM_URL.CONTAINER_CLUSETER, {size: 9999})
        .then((response) => {
            setContainerClusterList(response.data.items.map((data, index) => {
                if(!data.api_server_address) {
                    return false;
                }
                return { value: data.container_cluster_id, label: data.container_cluster_name };
            }).filter((v)=>{if(v !== false) return v}));
        })
        .catch((error) => {
            if(props.showMessageCb) {
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }
    // 네임스페이스 옵션리스트 조회
    function loadNamespaceList() {
        requests.get(PLATFORM_URL.CONTAINER_CLUSETER + '/' + containerClusterId + PLATFORM_URL.POD_NAMESPACE, {size: 9999})
        .then((response) => {
            if (response.status === 200 && response.data?.items) {
                setNamespaceList(response.data.items.map((data, index) => {
                    return { value: data.namespace_id, label: data.namespace_name };
                }));
            }
        })
        .catch((error) => {
            if(props.showMessageCb) {
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }
    function loadServiceList() {
        requests.get(PLATFORM_URL.CONTAINER_CLUSETER + '/' + containerClusterId + PLATFORM_URL.POD_SERVICE, {size: 9999})
        .then((response) => {
            const services = response.data.items?.map((data, index) => {
                return {
                    value: data.service_name,
                    label: data.service_name
                }
            }).filter((v)=>{if(v !== false) return v});

            setServiceList([{label: t("DIRECT_INPUT_TEXT"), value:""} ,...services]);
        })
        .catch((error) => {
            if(props.showMessageCb) {
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }

    
    function addRole() {
        if(props.showMessageCb){
            props.showMessageCb("");
        }
        
        setIngressRoles([...ingressRoles, newRole]);
        setNewRole({
            hostUrl: '',
            protocolTypeCode: 'HTTP',
            path: '',
            pathTypeCode: 'PREFIX',
            backendTypeCode: 'SVC',
            serviceSelectType: '',
            backendName: '',
            backendPort: 0,
            serviceId: ''
        });
        setRoleChangeYn(true);
    }

    function deleteRole(role) {
        const tempList = [...ingressRoles];

        setIngressRoles(tempList.filter(role => role.path !== role.path));
        setRoleChangeYn(true);
    }

    return (
        <View>
            {
                stepIndex === 0 ?
                // 이름, 설명, 사용 유형, 사용 대상
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("INGRESS_CREATE_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput 
                                key={1} 
                                width={560} height={36} 
                                value={ingressName} 
                                type={"text"} 
                                activeYn={true} 
                                inputCb={setIngressName} 
                                warnYn={ingressNameWarnYn} 
                                placeHolderText={t("NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowTopAlignContainer}>
                            <Text style={style.columnText}>
                                {t("DESCRIPTION_TEXT")}
                            </Text>
                            <TextArea 
                                key={2} 
                                width={570} height={100} 
                                value={ingressDescription} 
                                type={"text"} 
                                activeYn={true} 
                                inputCb={setIngressDescription} 
                                warnYn={false}
                                placeHolderText={t("DESCRIPTION_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowDivContainer}/>
                    </View>
                    <Text style={{...style.titleText, marginTop: 10}}>{
                        t("DETAIL_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        {/* 프로젝트 */}
                        <View style={style.rowContainer}>
                            <CustomText text={t("PROJECT_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown
                                key={48}
                                width={400} height={36}
                                items={projectList}
                                value={projectId}
                                setValue={setProjectId}
                                disable={false}
                                defaultvalue={{label:"", value:""}}
                            />
                        </View>
                        {/* 클러스터 */}
                        <View style={style.rowContainer}>
                            <CustomText text={t("CLUSTER_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown
                                key={46}
                                width={400} height={36}
                                items={containerClusterList}
                                value={containerClusterId}
                                setValue={setContainerClusterId}
                                disable={projectId ? false: true}
                                defaultvalue={{label:"", value:""}}
                            />
                        </View>
                        {/* 네임스페이스 */}
                        <View style={style.rowContainer}>
                            <CustomText text={t("NAMESPACE_SELECT_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown
                                key={3}
                                width={400} height={36}
                                items={namespaceList}
                                value={namespaceId}
                                setValue={setNamespaceId}
                                disable={containerClusterId ? false : true}
                                defaultvalue={{label:"", value:""}}
                                placeholder={t("SELECT_NAMESPACE_INFO_MESSAGE")}
                            />
                        </View>
                        {/* 클래스명 */}
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("INGRESS_TABLE_COLUMN_CLASS_NAME")}
                            </Text>
                            <CustomTextInput 
                                key={4} 
                                width={560} height={36} 
                                value={ingressClass}
                                type={"text"} 
                                activeYn={true} 
                                inputCb={setIngressClass} 
                                warnYn={false} 
                            />
                        </View>
                        {/* Annotations */}
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("ANNOTATION_TEXT")}
                            </Text>
                            <CustomTextInput 
                                key={4} 
                                width={560} height={36} 
                                value={ingressAnnotations}
                                type={"text"} 
                                activeYn={true} 
                                inputCb={setIngressAnnotation} 
                                warnYn={false} 
                            />
                        </View>
                        {/* 라벨 */}
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("INGRESS_ADD_LABEL_TEXT")}
                            </Text>
                            <CustomTextInput 
                                key={4} 
                                width={560} height={36} 
                                value={ingressLabel}
                                type={"text"} 
                                activeYn={true} 
                                inputCb={setIngressLabel} 
                                warnYn={false} 
                            />
                        </View>
                        {/* 규칙 */}
                        <View style={style.rowDivContainer}/>
                        <View>
                            <Text style={{...style.titleText, marginTop: 10}}>{
                                t("INGRESS_ADD_RULE_TEXT")}
                            </Text>
                            <View style={{paddingLeft:50}}>
                                {
                                    roleChangeYn === false ?
                                    ingressRoles.map((role, index) => {
                                        return (
                                            <View key={index * 1200} style={style.listMainContainer}>
                                                <div
                                                    style={{
                                                        display: "flex", alignItems: "center", justifyContent: "center",
                                                        width: 65, height: 24,
                                                        marginLeft: "auto",
                                                        borderRadius: 2, borderStyle: "solid", borderWidth: 1, borderColor: "#d4d0db",
                                                        backgroundColor: "#fff",
                                                        fontFamily: FONT.REGULAR,
                                                        fontSize: 12,
                                                        color: "#333",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => {deleteRole(role)}}
                                                >
                                                    {t("DELETE_TEXT")}
                                                    <CloseImg style={{marginLeft: 3}}/>
                                                </div>
                                                <View style={style.mainContainer}>
                                                    <View style={style.rowContainer}>
                                                        <Text style={style.columnText}>
                                                            {t("PATH_TEXT")}
                                                        </Text>
                                                        <CustomTextInput 
                                                            key={4} 
                                                            width={400} height={36} 
                                                            value={role.path}
                                                            type={"text"} 
                                                            activeYn={false} 
                                                            inputCb={(v)=>null}
                                                            warnYn={false} 
                                                        />
                                                    </View>
                                                </View>
                                            </View>
                                        )}) : null
                                        }
                                        {
                                            roleChangeYn === false ?
                                            <View style={style.listMainContainer}>
                                                <View style={style.mainContainer}>
                                                    <View style={style.rowContainer}>
                                                        <Text style={style.columnText}>
                                                            {t("HOST_TEXT")}
                                                        </Text>
                                                        <CustomTextInput 
                                                            key={11} 
                                                            width={400} height={36} 
                                                            value={newRole.hostUrl}
                                                            type={"text"} 
                                                            activeYn={true} 
                                                            inputCb={(text:string)=>{
                                                                setNewRole({...newRole, hostUrl: text});
                                                            }}
                                                            warnYn={false} 
                                                        />  
                                                    </View>
                                                    <View style={style.rowContainer}>
                                                        <Text style={style.columnText}>
                                                            {t("INGRESS_ADD_RULE_PROTOCOL_TEXT")}
                                                        </Text>
                                                        <CustomTextInput 
                                                            key={12} 
                                                            width={400} height={36} 
                                                            value={newRole.protocolTypeCode}
                                                            type={"text"} 
                                                            activeYn={false} 
                                                            inputCb={(text:string)=>{
                                                                
                                                            }}
                                                            warnYn={false} 
                                                        />
                                                    </View>
                                                    <View style={style.rowContainer}>
                                                        <CustomText text={t("PATH_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                                        <CustomTextInput 
                                                            key={4} 
                                                            width={400} height={36} 
                                                            value={newRole.path}
                                                            type={"text"} 
                                                            activeYn={true} 
                                                            inputCb={(text:string)=>{
                                                                setNewRole({...newRole, path: text})
                                                            }}
                                                            warnYn={false} 
                                                        />
                                                    </View>
                                                    <View style={style.rowContainer}>
                                                        <Text style={style.columnText}>
                                                            {t("SERVICE_TEXT")}
                                                        </Text>
                                                        <CustomDropDown
                                                            key={48} 
                                                            width={414} height={36} 
                                                            items={serviceList}
                                                            value={newRole.backendName} 
                                                            setValue={(text:string)=>{
                                                                setNewRole({...newRole, backendName: text})
                                                            }} 
                                                            disable={false}
                                                            defaultvalue={{label:t("DIRECT_INPUT_TEXT"), value:""}}
                                                        />
                                                    </View>
                                                    <View style={style.rowContainer}>
                                                    <CustomText text={t("SERVICE_NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                                    <CustomTextInput
                                                        key={306}
                                                        width={570} height={36}
                                                        value={newRole.backendName}
                                                        type={"text"}
                                                        activeYn={true}
                                                        inputCb={(v)=>{setNewRole({...newRole, backendName: v})}}
                                                        warnYn={false}
                                                        placeHolderText={t("NAME_ENTER_MESSAGE")}
                                                    />
                                                </View>
                                                    <View style={style.rowContainer}>
                                                        <Text style={style.columnText}>
                                                            {t("PORT_TEXT")}
                                                        </Text>
                                                        <CustomTextInput 
                                                            key={4} 
                                                            width={400} height={36} 
                                                            value={newRole.backendPort + ""}
                                                            type={"number"} 
                                                            activeYn={true} 
                                                            inputCb={(text:string)=>{
                                                                setNewRole({...newRole, backendPort: Number(text)})
                                                            }}
                                                            warnYn={false} 
                                                        />
                                                    </View>
                                                    <div
                                                        style={{
                                                            display: "flex", alignItems: "center", justifyContent: "center",
                                                            width: 65, height: 24,
                                                            marginLeft: "auto",
                                                            borderRadius: 2, borderStyle: "solid", borderWidth: 1, borderColor: "#d4d0db",
                                                            backgroundColor: "#fff",
                                                            fontFamily: FONT.REGULAR,
                                                            fontSize: 12,
                                                            color: "#333",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() => {addRole()}}
                                                    >
                                                        {t("ADD_TEXT")}
                                                        <MoreImg style={{marginLeft: 3}}/>
                                                    </div>
                                                </View>
                                            </View>
                                        : null
                                        }
                            </View>
                        </View>
                    </View>
                </View>
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",
    },
    mainContainer: {
        marginTop: 38
    },
    listMainContainer: {
        marginTop: 38,
        paddingTop: 20,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
        borderRadius: 10,
        borderColor: "#9ea0a5",
        borderWidth: 0.5,
        marginBottom: 20,
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    requireText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#e86045"
    },
    infoText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#8c8c8c"
    },
    labelStyle: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    }
});